import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

export const QuejaWizardContext = createContext({ queja: {} });

const QuejaWizardProvider = ({ children }) => {
  const [queja, setQueja] = useState({});
  const [step, setStep] = useState(1);
  const [selectedDelegacionDescription, setSelectedDelegacionDescription] =
    useState('');
  const [selectedSubcustomerDescription, setSelectedSubcustomerDescription] =
    useState('');
  const [selectedDeterminanteDescription, setSelectedDeterminanteDescription] =
    useState('');

  const [selectedTipoProductoDescription, setSelectedTipoProductoDescription] =
    useState('');
  const [
    selectedClasificacionDescription,
    setSelectedClasificacionDescription
  ] = useState('');
  const [
    selectedClasificacionWmDescription,
    setSelectedClasificacionWmDescription
  ] = useState('');
  const [
    selectedClasificacionProfecoDescription,
    setSelectedClasificacionProfecoDescription
  ] = useState('');
  const [formatoQuejaSelected, setFormatoQuejaSelected] = useState('');

  const value = {
    queja,
    setQueja,
    step,
    setStep,
    selectedDelegacionDescription,
    setSelectedDelegacionDescription,
    selectedSubcustomerDescription,
    setSelectedSubcustomerDescription,
    selectedDeterminanteDescription,
    setSelectedDeterminanteDescription,
    selectedTipoProductoDescription,
    setSelectedTipoProductoDescription,
    selectedClasificacionDescription,
    setSelectedClasificacionDescription,
    selectedClasificacionWmDescription,
    setSelectedClasificacionWmDescription,
    selectedClasificacionProfecoDescription,
    setSelectedClasificacionProfecoDescription,
    formatoQuejaSelected,
    setFormatoQuejaSelected
  };
  return (
    <QuejaWizardContext.Provider value={value}>
      {children}
    </QuejaWizardContext.Provider>
  );
};

QuejaWizardProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useQuejaWizardContext = () => useContext(QuejaWizardContext);

export default QuejaWizardProvider;
